/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UnitType } from '@src/app/model/unit-type';
import { AbstractHttpService } from '@src/app/shared/abstract-http.service';
import { MessageService } from '@src/app/shared/message.service';
import { UnitCategory } from '@src/app/model/unit-category';
@Injectable({
  providedIn: 'root'
})
export class UnitTypeService extends AbstractHttpService {
  protected http = inject(HttpClient);
  protected messageService = inject(MessageService);


  protected typeString = 'UnitTypes';
  protected get baseUrl(): string {
    return this.getAjaxPath('units/types');
  }

  protected cache: UnitType[] = [];

  getCategories(types : UnitType[] = this.cache) : UnitCategory[] {
    const categories: UnitCategory[] = [];
    types.forEach( t => {
        t.categories.forEach( c => {
            categories.push(c);
        })
    })
    return categories;
  }
}
